// Standard screen-reader-only recipe. Its parent must be positioned (position: relative), or the
// absolute span escapes the page's scroll container and adds phantom scrollable height.
export const visuallyHiddenStyle = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
} as const;
